import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // get Scan Category
  getListScanCategory,
  getListScanCategoryDataApiSuccess,
  getListScanCategoryDataApiFailed,

  // get Scan test
  getListScanTest,
  getListScanTestDataApiSuccess,
  getListScanTestDataApiFailed,

  // Add lab Test
  addScanCategory,
  addScanCatagoriesDataApiSuccess,
  addScanCatagoriesDataApiFailed,

  // Add Scan Test
  addScanTest,
  addScanTestDataApiSuccess,
  addScanTestDataApiFailed,

  // Update Scan Category
  updateScanCategoryData,
  updateScanCategoryDataApiSuccess,
  updateScanCategoryDataApiFailed,
  // Update Scan Test
  updateScanCenterTest,
  updateScanCenterTestApiSuccess,
  updateScanCenterTestApiFailed,
  // delete Scan category data
  deleteScanCategory,
  deleteScanCategoryDataApiSuccess,
  deleteScanCategoryDataApiFailed,
  // delete Scan Test
  deleteScanTest,
  deleteScanTestApiSuccess,
  deleteScanTestApiFailed,
  // getScanCategoryDetails
  getScanCategoryDetails,
  getScanCategoryDetailsApiSuccess,
  getScanCategoryDetailsFailed,
} from './slice'
import { API } from 'src/scanCenter/services/index'

function* getListScanCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.getListScanCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(getListScanCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(getListScanCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getListScanCategoryDataApiFailed({ message: error?.message }))
  }
}
function* getListScanTestDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.getListScanTestData, payload)
    if (
      response?.status === 200 &&
      response?.data
      // response?.data?.code === 0 &&
      // response?.data?.error === false
    ) {
      yield put(getListScanTestDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(getListScanTestDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getListScanTestDataApiFailed({ message: error?.message }))
  }
}

function* addScanCatagoriesDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.addScanCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(addScanCatagoriesDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(addScanCatagoriesDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(addScanCatagoriesDataApiFailed({ message: error?.message }))
  }
}
function* addScanTestDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.addScanTestData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(addScanTestDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(addScanTestDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(addScanTestDataApiFailed({ message: error?.message }))
  }
}

function* updateScanCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.updateScanCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(updateScanCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateScanCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(updateScanCategoryDataApiFailed({ message: error?.message }))
  }
}
function* updateScanCenterTestDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.updateScanTest, payload)
    if (response?.status === 200 && response?.data) {
      yield put(updateScanCenterTestApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateScanCenterTestApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(updateScanCenterTestApiFailed({ message: error?.message }))
  }
}
function* deleteScanCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.deleteScanCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(deleteScanCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteScanCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(deleteScanCategoryDataApiFailed({ message: error?.message }))
  }
}
function* deleteScanTestApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.deleteScanTest, payload)
    if (response?.status === 200 && response?.data) {
      yield put(deleteScanTestApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteScanTestApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(deleteScanTestApiFailed({ message: error?.message }))
  }
}
function* getScanCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.manageScanCenter.getScanCategoryDetails, payload)
    if (response?.status === 200 && response?.data) {
      yield put(getScanCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getScanCategoryDetailsFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getScanCategoryDetailsFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(getListScanCategory, getListScanCategoryDataApi)
  yield takeEvery(getListScanTest, getListScanTestDataApi)
  yield takeEvery(addScanCategory, addScanCatagoriesDataApi)
  yield takeEvery(addScanTest, addScanTestDataApi)

  yield takeEvery(updateScanCategoryData, updateScanCategoryDataApi)
  yield takeEvery(updateScanCenterTest, updateScanCenterTestDataApi)
  yield takeEvery(deleteScanCategory, deleteScanCategoryDataApi)
  yield takeEvery(deleteScanTest, deleteScanTestApi)
  yield takeEvery(getScanCategoryDetails, getScanCategoryDetailsApi)
}

export default authSaga
